var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main-loading-header"},[_c('OsiguLogo',{staticClass:"main-loading-header__logo"})],1),_c('div',{staticClass:"main-loading"},[_c('Loading')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }